import React, { type ElementType, forwardRef } from 'react';

import { useMergeRefs } from '../../hooks/useMergeRefs';

import { OverflowContext } from './Overflow.context';
import * as Primitives from './Overflow.parts';

import type { OverflowType } from './useOverflow';

type OverflowProps = {
    as?: ElementType;
    overflow: OverflowType;
} & Omit<React.HTMLAttributes<HTMLElement>, 'id'>;

const OverflowRoot = forwardRef<HTMLElement, OverflowProps>(
    ({ children, as: Component = 'div', overflow, ...props }, ref) => {
        const mergedRef = useMergeRefs([overflow.itemsContainerRef, ref]);
        return (
            <OverflowContext.Provider value={overflow}>
                <Component ref={mergedRef} {...props}>
                    {children}
                </Component>
            </OverflowContext.Provider>
        );
    }
);
OverflowRoot.displayName = 'Overflow';

type OverflowCompound = typeof OverflowRoot & typeof Primitives;

export const Overflow = Object.assign(OverflowRoot, Primitives) as OverflowCompound;
